import { render } from "./UserAddress.vue?vue&type=template&id=7e7142b6&scoped=true"
import script from "./UserAddress.vue?vue&type=script&lang=js"
export * from "./UserAddress.vue?vue&type=script&lang=js"

import "./UserAddress.vue?vue&type=style&index=0&id=7e7142b6&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7142b6"]])

export default __exports__